<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar />
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex"></div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <div class="card" style="border: none; position: -webkit-sticky; position: sticky; top: 0; z-index: 10;">
                                    <div class="lessor-border-3 lessor-rounded pl-3 pr-3 pt-1 pb-1 shadow-sm">
                                        <div class="d-flex justify-content-between p-2" v-if="!loadingData">
                                            <div>
                                                <div>
                                                    <b>Order ID</b>
                                                    <br />
                                                    {{orderCode}}
                                                </div>
                                                <div class="mt-2">
                                                    <b>Product Title</b>
                                                    <br />
                                                    {{productName}}
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <b>Lessee Name</b>
                                                    <br />
                                                    {{lesseeName}}
                                                </div>
                                                <div class="mt-2">
                                                    <b>Catalog Spec</b>
                                                    <br />
                                                    {{getConditionName(condition,$getConst('CONDITION'))}} - {{specificationsView}}
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <b>Rent Duration</b>
                                                    <br />
                                                    {{duration}} Months
                                                </div>
                                                <div class="mt-2">
                                                    <b>Quantity</b>
                                                    <br />
                                                    {{maxQty}} Units
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row text-center" v-else>
                                            <div style="margin: auto;">
                                                <img src="~@/assets/images/load-button.gif" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="!loadingData">
                                    <div class="card mt-4" style="border: none;" v-for="(input, index) in dataItemPoint" :key="`itemPoint-${index}`">
                                        <div class="d-flex flex-row-reverse" v-if="index != 0">
                                            <div class="lessor-bg-content lessor-bg-icon-delete p-2 text-center" @click="removeRow(index)">
                                                <img src="@/assets/icon/set-lessor/delet_icon.png" class="lessor-icon-delete" />
                                            </div>
                                        </div>
                                        <div class="lessor-rounded lessor-bg-content pb-2">
                                            <div class="row mt-4 ml-2 mr-4">
                                                <!-- <div class="col-6" v-if="input.lessorPoint.lessorId != 4">
                                                    <div class="row lessor-bg-content-field lessor-rounded lessor-m-pickup">
                                                        <div class="col-4 pl-0">
                                                            <img src="@/assets/icon/set-lessor/pickup.png" class="lessor-icon-pickup" />
                                                        </div>
                                                        <div class="col-8 d-flex">
                                                            <div class="align-self-center w-100">
                                                                <b>Pickup Schedule</b>
                                                                <br />
                                                                <input type="date" class="form-control input-deliver" name="" :id="index" v-model="input.pickupDate" :min="todayDate" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                                <div class="col-lg-12">
                                                    <div class="row lessor-bg-content-field lessor-rounded lessor-m-delivery">
                                                        <div class="pl-0 col-2">
                                                            <img src="@/assets/icon/set-lessor/delivery.png" class="lessor-icon-delivery" />
                                                        </div>
                                                        <div class="d-flex col-10">
                                                            <div class="align-self-center w-100">
                                                                <b>Deliver Schedule</b>
                                                                <br />
                                                                <input type="date" class="form-control input-deliver" name="" v-model="deliveryDate" :min="todayDate" />
                                                                <div class="paymentDateChips py-1 mt-1" :style="`background-color: #FFF4EB;`">
                                                                    <span class="option__title" style="font-weight : 500;">
                                                                        <img src="~@/assets/icon/warning-icon.png" width="16px" height="16px" style="margin-bottom : 2px;"/>
                                                                        <span style="font-size: 0.75rem;">Payment Date : {{ paymentDate }}</span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-4 ml-4 mr-4 mb-4 lessor-bg-content-field lessor-rounded lessor-m-delivery">
                                                <div class="col-2 pl-0">
                                                    <img src="@/assets/icon/set-lessor/lessor_warehouse.png" v-if="input.lessorPoint.lessorId!=null && input.lessorPoint.stock != '1'" class="lessor-icon" />
                                                    <img src="@/assets/icon/set-lessor/lessor_warehouse.png" v-else class="lessor-icon" />
                                                </div>
                                                <div class="col-10 d-flex">
                                                    <div class="align-self-center w-100">
                                                        <div class="d-flex">
                                                            <div class="w-100 mr-1">
                                                                <b>Warehouse</b>
                                                                <br />
                                                                <multiselect
                                                                    v-model="lessorSelect"
                                                                    :options="warehouseList"
                                                                    
                                                                    :allow-empty="false"
                                                                    deselect-label=""
                                                                    
                                                                    select-label=""
                                                                    style=""
                                                                    placeholder="Pilih Warehouse"
                                                                ></multiselect>
                                                            </div>
                                                        </div>
                                                        <div v-if="input.lessorPoint!=null && input.lessorPoint.stock==0 && input.lessorPoint.lessorId!=4">
                                                            <b>Qty</b>
                                                            <br />
                                                            <input type="text" name="quantity" class="form-control mr-1" v-model="input.quantity" @keypress="isNumber($event)" placeholder="Qty" @input="minimumcharacters(input, 'qty')" />
                                                        </div>
                                                        <div v-if="input.lessorPoint != null && input.lessorPoint.stock == '1'">
                                                            <div class="row">
                                                                <div class="col-4">
                                                                    <b>Qty</b>
                                                                    <br />
                                                                    <input type="text" name="quantity" class="form-control mr-1" v-model="input.quantity" @keypress="isNumber($event)" placeholder="Qty" @input="minimumcharacters(input, 'qty')" />
                                                                </div>
                                                                <div class="col-8" v-if="input.lessorPoint!=null&&input.lessorPoint.lessorId != 4&&input.lessorPoint.stock == 1">
                                                                    <b>Price Per Unit</b>
                                                                    <br />
                                                                    <div class="input-group">
                                                                        <span class="input-group-addon"> <label class="label-addon-rp">Rp</label></span>
                                                                        <money type="text" class="form-control form-input input-lg" name="price" v-bind="money" @keypress="isNumber($event)" v-model="input.stockPrice"></money>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="input.lessorPoint!=null&&input.lessorPoint.lessorId==4">
                                                <div class="row mt-2 ml-4 mr-4 mb-2 lessor-rounded lessor-border-3" v-for="(dataStock, idx) in input.stocks.availableStock" :key="`stock-${idx}`">
                                                    <vsa-list>
                                                        <vsa-item :initActive="idx==0">
                                                            <vsa-heading>
                                                                <span class="title-accordion">
                                                                    {{dataStock.productTitle}} {{dataStock.specificationsView}} - {{getConditionName(dataStock.stockCondition,$getConst('CONDITION'))}}
                                                                </span>
                                                            </vsa-heading>

                                                            <vsa-content>
                                                                <div class="row lessor-bg-content lessor-rounded stock-code-item">
                                                                    <div class="col-auto lessor-bg-content-stock-count lessor-rounded d-flex">
                                                                        <div class="align-self-center justify-content-center w-100 p-4">
                                                                            <div class="text-center stock-count">
                                                                                {{dataStock.stockCodes.length}}
                                                                            </div>
                                                                            <div class="text-center">
                                                                                Total Stock
                                                                            </div>
                                                                            <div class="text-center stock-count mt-3">
                                                                                {{cartCounts(dataStock,dataStock.stockCodes, input.selectedIds)}}
                                                                            </div>
                                                                            <div class="text-center">
                                                                                Cart
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col d-flex flex-wrap align-content-start p-4">
                                                                        <div class="w-100">
                                                                            <input
                                                                                style="margin-right: 5px; margin-top: 5px;"
                                                                                type="checkbox"
                                                                                :id="'select'+idx"
                                                                                :value="index"
                                                                                v-model="dataStock.selectAll"
                                                                                @change="selectAllCheckboxes(dataStock, input, index)"
                                                                            />
                                                                            <label>Select All</label>
                                                                        </div>
                                                                        <div class="col-4 pl-0" v-for="(cInput, k) in dataStock.stockCodes" :key="`stokCode-${k}`">
                                                                            <div>
                                                                                <input
                                                                                    style="margin-right: 5px; margin-top: 5px;"
                                                                                    type="checkbox"
                                                                                    :id="cInput.stockCode"
                                                                                    :value="cInput.stockId"
                                                                                    v-model="input.selectedIds"
                                                                                    @change="selectOneItem(dataStock,index)"
                                                                                />
                                                                                <label :for="cInput.stockCode">{{cInput.stockCode}}</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </vsa-content>
                                                        </vsa-item>
                                                    </vsa-list>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex bd-highlight mb-3" v-if="!loadingData">
                                    <div class="mr-auto p-2 bd-highlight">
                                        <button class="btn btn-primary" @click="toDetail(orderId,orderCode,companyId)">Cancel</button>
                                    </div>
                                    <div class="p-2 bd-highlight">
                                        <!-- <button class="btn btn-primary" @click="addRow(idx)">More Lessor</button> -->
                                        <button class="btn btn-primary ml-2" @click="submitAssignTo(productId,1,'save')" v-if="!loadingButton && action == 'set'">Submit</button>
                                        <button class="btn btn-primary ml-2" @click="submitAssignTo(productId,1,'edit')" v-else-if=" !loadingButton && action == 'edit'">Submit</button>
                                        <button type="button" class="btn btn-primary" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;" />Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from '../SideBar'
import Multiselect from 'vue-multiselect'
import {
    Money
} from 'v-money'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon
} from 'vue-simple-accordion';
export default {
    name: 'OrderPage',
    components: {
        SideBar,
        Multiselect,
        VsaList,
        VsaItem,
        VsaHeading,
        VsaContent,
        VsaIcon,
        Money
    },
    data() {
        return {
            spaceRegex : /[\u00A0\uFEFF\u202F]/g,
            admin: "",
            adminId: "",
            permission: [],
            viewDashboard: false,
            viewOrder: false,
            viewReturn: false,
            viewProduct: false,
            viewPairing: false,
            viewReconcile: false,
            viewResolution: false,
            viewLessor: false,
            viewLessee: false,
            viewEmployee: false,
            editOrder: false,
            editReturn: false,
            editProduct: false,
            editPairing: false,
            editReconcile: false,
            editResolution: false,
            editLessor: false,
            editLessee: false,
            editEmployee: false,
            lessorSelect: '',
            companyName: "",
            itemStatus: 0,
            loadingButton: false,
            loadingData: true,
            todayDate: '',

            productId: '',
            orderId: '',
            condition: '',
            dataLessorPoint: [],

            orderCode: '',
            productName: '',
            maxQty: 0,
            lesseeName: '',
            conditionName: '',
            specificationsView: '',
            duration: 0,
            companyId: '',
            action: '',
            route: '',

            stocks: [],
            dataItemPoint: [],
            aStock: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            deliveryDate: '',
            previousDate: '',
            warehouseList: [],
            paymentDate : '',
        }
    },
    methods: {
        formatRupiah(angka) {
            var number_string = angka.replace(/[^,\d]/g, '').toString(),
                split = number_string.split(','),
                sisa = split[0].length % 3,
                rupiah = split[0].substr(0, sisa),
                ribuan = split[0].substr(sisa).match(/\d{3}/gi);

            // tambahkan titik jika yang di input sudah menjadi angka ribuan
            if (ribuan) {
                if (sisa === 0) {
                    return ribuan.join('.')
                } else {
                    return rupiah + '.' + ribuan.join('.')
                }
            } else {
                return parseInt(angka).toString()
            }
        },
        previousDataValid() {
            var totalQuantity = 0
            for (var i = 0; i < this.dataItemPoint.length; i++) {
                var qtyMessageError = "Minimum Quantity is 1"
                if (this.dataItemPoint[i].lessorPoint.lessorId == 4) {
                    this.dataItemPoint[i].quantity = this.dataItemPoint[i].selectedIds.length
                    qtyMessageError = "Please select a stock"
                }
                if (this.dataItemPoint[i].deliveryDate == '' || this.dataItemPoint[i].deliveryDate == null) {
                    swal("Sorry", "Delivery date must be pick", "error", {
                        button: "Close",
                    })
                    return 0
                } else if (this.dataItemPoint[i].lessorPoint.pointId == '' || this.dataItemPoint[i].lessorPoint.pointId == -1) {
                    swal("Sorry", "Lessor point must be select", "error", {
                        button: "Close",
                    })
                    return 0
                } else if (this.dataItemPoint[i].quantity == '' || this.dataItemPoint[i].quantity == '0') {
                    swal("Sorry", qtyMessageError, "error", {
                        button: "Close",
                    })
                    return 0
                } else if (this.dataItemPoint[i].lessorPoint.lessorId != 4 && this.dataItemPoint[i].lessorPoint.stock == 1 && (this.dataItemPoint[i].stockPrice == '0' || this.dataItemPoint[i].stockPrice == '' || this.dataItemPoint[i].stockPrice == null)) {
                    swal("Sorry", "Price per unit must be entered", "error", {
                        button: "Close",
                    })
                    return 0
                }
                totalQuantity = totalQuantity + this.$route.query.qty
            }
            if (totalQuantity === parseInt(this.maxQty)) return 2
            if (totalQuantity < parseInt(this.maxQty)) return 1
            swal("Sorry", "Total Quantity must be " + this.maxQty, "error", {
                button: "Close",
            })
            return 0
        },
        // defaultData(index) {
        //     return {
        //         pickupDate: "",
        //         deliveryDate: "",
        //         quantity: 0,
        //         selectedIds: [],
        //         lessorPoint: this.parseLessorData(-1, -1, -1, 'Select Lessor Point'),
        //         stockPrice: '0',
        //         stocks: this.getSelectedAndAvailableStocks(index)
        //     }
        // },
        parseData(index, pDate, dDate, qQty, sLessorId, sPointId, sStock, sPointName, sPrice, selectedIds) {
            var sp = "0"
            if (sPrice != null) sp = sPrice.toString()
            return {
                pickupDate: pDate,
                deliveryDate: dDate,
                quantity: qQty,
                selectedIds: selectedIds,
                lessorPoint: this.parseLessorData(sLessorId, sPointId, sStock, sPointName),
                stockPrice: sp,
                stocks: []
            }
        },
        initSelectedIds(stockIds) {
            var result = []
            if (stockIds != null && stockIds != "") {
                var splitStock = stockIds.split(",")
                for (var i = 0; i < splitStock.length; i++) {
                    result.push(parseInt(splitStock[i]))
                }
            }
            return result
        },
        parseLessorData(sLessorId, sPointId, sStock, sPointName) {
            return {
                lessorId: sLessorId,
                pointId: sPointId,
                stock: sStock,
                pointName: sPointName
            }
        },
        parseSelectedStock(sLessorId) {
            return {
                availableStock: sLessorId
            }
        },
        getOtherStockIds(excludeIndex) {
            var result = []
            for (var i = 0; i < this.dataItemPoint.length; i++) {
                if (i != excludeIndex) {
                    if (this.dataItemPoint[i].hasOwnProperty('selectedIds')) {
                        for (var a = 0; a < this.dataItemPoint[i].selectedIds.length; a++) {
                            result.push(this.dataItemPoint[i].selectedIds[a])
                        }
                    } else console.log("error1")
                }
            }
            return result
        },
        syncData() {
            for (var i = 0; i < this.dataItemPoint.length; i++) {
                this.dataItemPoint[i].stocks.availableStock = this.getAvailableStocksss(i)
                if (this.dataItemPoint[i].lessorPoint.lessorId == 4) {
                    this.initSelectAll(this.dataItemPoint[i].stocks.availableStock, this.dataItemPoint[i].selectedIds)
                } else {
                    this.dataItemPoint[i].selectedIds = []
                }
            }
        },
        // getAvailableStocksss(index) {
        //     // OUR MAGIC IS IN HERE!! DEBUG THIS CODE TO VALIDATE
        //     var mustNotIncludeStockId = this.getOtherStockIds(index)
        //     var dStocks = []
        //     console.log('stocks',this.stocks)
        //     for (var i = 0; i < this.stocks.length; i++) {
        //         var dStock = this.copyWithoutReference(this.stocks[i])
        //         var hasilStockCode = []
        //         for (var j = 0; j < this.stocks[i].stockCodes.length; j++) {
        //             var dStockCode = this.stocks[i].stockCodes[j]
        //             var duplicate = false
        //             for (var k = 0; k < mustNotIncludeStockId.length; k++) {
        //                 if (dStockCode.stockId != mustNotIncludeStockId[k]) {
        //                     for (var l = 0; l < hasilStockCode.length; l++) {
        //                         if (hasilStockCode[l].stockId == dStockCode.stockId) {
        //                             duplicate == true
        //                         }
        //                     }
        //                 } else {
        //                     duplicate = true
        //                 }
        //             }
        //             if (!duplicate) {
        //                 hasilStockCode.push(dStockCode)
        //             }
        //         }
        //         if (hasilStockCode.length > 0) {
        //             dStock.stockCodes = hasilStockCode
        //             dStocks.push(dStock)
        //         }
        //     }
        //     var result = this.copyWithoutReference(dStocks)
        //     return result
        // },
        // initSelectAll(availableStock, selectedIds) {
        //     for (var i = 0; i < availableStock.length; i++) {
        //         var sSelectAll = true
        //         for (var j = 0; j < availableStock[i].stockCodes.length; j++) {
        //             var sStockId = availableStock[i].stockCodes[j].stockId
        //             // [1, 2, 3].includes(4); false
        //             if (!selectedIds.includes(sStockId)) {
        //                 sSelectAll = false
        //             }
        //         }
        //         availableStock[i].selectAll = sSelectAll
        //     }
        // },
        // getSelectedAndAvailableStocks(index) {
        //     var result = this.getAvailableStocksss(index)

        //     return this.parseSelectedStock(result)
        // },
        copyWithoutReference(objectData) {
            return JSON.parse(JSON.stringify(objectData))
        },
        // totalAvailableStock() {
        //     let total = 0
        //     for (var i = 0; i < this.dataItemPoint.length; i++) {
        //         if (this.dataItemPoint[i].lessorPoint.lessorId === 4) {
        //             total = total + this.dataItemPoint[i].selectedIds.length
        //         }
        //     }
        //     return this.totalDefaultStock() - total
        // },
        // totalDefaultStock() {
        //     let total = 0
        //     for (var i = 0; i < this.stocks.length; i++) {
        //         total = total + this.stocks[i].total
        //     }
        //     return total
        // },
        resetFromRecentStockCodes(listToRemove, listAll) {
            var result = []
            var sRemove = this.copyWithoutReference(listToRemove)
            var sList = this.copyWithoutReference(listAll)
            for (var i = 0; i < listAll.length; i++) {
                var same = false
                for (var j = 0; j < listToRemove.length; j++) {
                    if (listToRemove[j].stockId == listAll[i]) {
                        same = true
                    }
                }
                if (!same) {
                    result.push(listAll[i])
                }
            }
            return result
        },
        cartCounts(dt, data, sInput) {
            var result = 0
            for (var i = 0; i < sInput.length; i++) {
                var same = false
                for (var j = 0; j < data.length; j++) {
                    if (data[j].stockId == sInput[i]) {
                        same = true
                    }
                }
                if (same) {
                    result++
                }
            }
            if (result == data.length) {
                dt.selectAll = true
            } else {
                dt.selectAll = false
            }

            return result
        },
        selectAllCheckboxes(data, sInput, index) {
            sInput.selectedIds = this.resetFromRecentStockCodes(data.stockCodes, sInput.selectedIds)
            if (data.selectAll == true) {
                for (var j = 0; j < data.stockCodes.length; j++) {
                    sInput.selectedIds.push(data.stockCodes[j].stockId)
                }
            }
        },
        selectOneItem(data, index) {
            if (data.selectedStock.length != data.stockCodes.length) {
                data.selectAll = false
            } else data.selectAll = true
            this.syncData()
        },
        sendLog(codeLogs, data) {
            var today = new Date();
            var month = today.getMonth() + 1
            if (month < 10) {
                month = '0' + month
            }
            var dateDay = today.getDate()
            if (dateDay < 10) {
                dateDay = '0' + dateDay
            }
            var hours = today.getHours()
            if (hours < 10) {
                hours = '0' + hours
            }
            var minutes = today.getMinutes()
            if (minutes < 10) {
                minutes = '0' + minutes
            }
            var second = today.getSeconds()
            if (second < 10) {
                second = '0' + second
            }
            var date = today.getFullYear() + '-' + month + '-' + dateDay;
            var time = hours + ":" + minutes + ":" + second;
            var dateTime = date + ' ' + time;
            var admin = this.admin
            var command = 'add-logs'
            if (data == 'assignTo') {
                var productTitle = this.productName !== null ? this.productName.replace(this.spaceRegex, ' ') : this.productName
                for (var i = 0; i < this.dataItemPoint.length; i++) {
                    var pointName = this.dataItemPoint[i].lessorPoint.pointName
                    var qty = this.dataItemPoint[i].quantity

                    this.$http.post(process.env.LOG_URL + "/" + this.route + "/" + this.orderId, {
                            codeLogs: codeLogs,
                            params: [pointName, productTitle, qty],
                        }, {
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            this.connectLogOrder()
                        })
                        .catch(error => {
                            console.log(error)
                        })
                }
            }
        },
        connectLogOrder: function() {
            var route = this.route
            var orderId = this.orderId

            this.$http.get(process.env.LOG_URL + "/" + route + "/" + orderId, {
                    headers: {
                        'Asani-Token': localStorage.getItem('jwt')
                    }
                })
                .then(response => {
                    if (response.data.status === 200) {
                        this.dataLog = response.data.content
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        toDetail(id, orderCode, companyId) {
            this.$router.push({
                path: '/order/detail/' + id,
                query: {
                    orderCode: orderCode,
                    companyIdDetail: companyId
                }
            })
        },
        minimumcharacters(field, sFrom) {
            if (sFrom == 'qty') {
                if (field.quantity == "") {
                    field.quantity = 0
                } else {
                    field.quantity = parseInt(field.quantity)
                    if (field.quantity < 1) {
                        field.quantity = 0
                    }
                }
            } else if (sFrom == 'stock') {
                if (field.stockPrice == "") {
                    field.stockPrice = '0'
                } else {
                    let jml = field.stockPrice
                    field.stockPrice = this.formatRupiah(field.stockPrice)
                    if (jml < 1) {
                        field.stockPrice = '0'
                    }
                }
            }
        },
        checkData() {
            if(!this.lessorSelect.pointName) {
                swal()
            }
        },
        submitAssignTo(x, pagePost, processData) {
            var valid = true
            if(!this.deliveryDate) {
                valid = false
                swal('Error', 'Mohon isi tanggal pengiriman', 'error')
            }
            if(!this.lessorSelect) {
                valid = false
                swal('Error', 'Mohon isi Lessor Point', 'error')
            }
            var self = this
            if (valid) {
                this.loadingButton = true
                
                if (processData == 'edit') {
                    let notetxt = this.$route.query.note
                    if(!notetxt) {
                        notetxt = null
                    } 
                    else {
                        notetxt = notetxt ? notetxt.replace(this.spaceRegex, ' ') : notetxt
                    }
                    let url = process.env.EDIT_LESSOR_ORDER
                    this.$http.post(url, {
                        "orderId": this.orderId,
                        "productId": this.productId,
                        "condition": this.condition,
                        "orderItemStatus": this.$route.query.orderItemStatus,
                        "deliveryDateBefore": this.previousDate,
                        "deliveryDateTo": this.deliveryDate,
                        "orderItemDuration": this.$route.query.orderItemDuration,
                        "quantity": this.$route.query.qty,
                        "pickupPlace": this.lessorSelect,
                        "note": notetxt,
                        "price" : this.$route.query.price,
                    }, {
                        timeout: 30 * 1000,
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        console.log(response)
                        if (response.data.status == 200) {
                            this.sendLog(19, 'assignTo')
                            swal("Success", "Success to set lessor of order ID " + this.orderId, "success", {
                                button: "Ok",
                            }).then((value) => {
                                this.toDetail(this.orderId, this.orderCode, this.companyId)
                            })
                        }
                        if (response.data.status == 202) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Close",
                            })
                            this.loadingButton = false
                            return
                        }
                        if (response.data.status == 201) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Close",
                            })
                            this.loadingButton = false
                        }
                        if (response.data.content == 0) {
                            $('#modalAssignTo').modal('hide')
                        }
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Close",
                            })
                            this.handleLogout()
                        }
                    })
                    .catch(error => {
                        // alert('Request timeout / error with api, please try again!')
                        self.loadingButton = false
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                            this.handleLogout()
                            }
                        })
                    })
                } else {
                    let notetxt = this.$route.query.note
                    if(!notetxt) {
                        notetxt = null
                    } 
                    else {
                        notetxt = notetxt ? notetxt.replace(this.spaceRegex, ' ') : notetxt
                    }
                    console.log(`note : ${notetxt}`)
                    this.$http.post(process.env.SET_LESSOR_ORDER, {
                        "orderId": this.orderId,
                        "productId": this.productId,
                        "condition": this.condition,
                        "orderItemStatus": this.$route.query.orderItemStatus,
                        "deliveryDate": this.deliveryDate,
                        "orderItemDuration": this.$route.query.orderItemDuration,
                        "quantity": this.$route.query.qty,
                        "pickupPlace": this.lessorSelect,
                        "note": notetxt,
                        "price" : this.$route.query.price,
                    }, {
                        timeout: 30 * 1000,
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 200) {
                            this.sendLog(19, 'assignTo')
                            swal("Success", "Success to set lessor of order ID " + this.orderId, "success", {
                                button: "Ok",
                            }).then((value) => {
                                this.toDetail(this.orderId, this.orderCode, this.companyId)
                            })
                        }
                        if (response.data.status == 202) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Close",
                            })
                            this.loadingButton = false
                            return
                        }
                        if (response.data.status == 201) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Close",
                            })
                            this.loadingButton = false
                        }
                        if (response.data.content == 0) {
                            $('#modalAssignTo').modal('hide')
                        }
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Close",
                            })
                            this.handleLogout()
                        }
                    })
                    .catch(error => {
                        // alert('Request timeout / error with api, please try again!')
                        self.loadingButton = false
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                            this.handleLogout()
                            }
                        })
                    })
                }

                
            } else if (valid === 1) {
                swal("Sorry", "Total Quantity must be " + this.maxQty, "error", {
                    button: "Close",
                })
            }
        },
        addRow(x) {
            var index = x + 1
            var valid = this.previousDataValid()
            if (valid === 1) {
                this.dataItemPoint.push(this.defaultData(x))
            } else if (valid === 2) {
                swal("Sorry", "Quantity fulfilled", "error", {
                    button: "Close",
                })
            }
        },
        removeRow(x) {
            this.dataItemPoint.splice(x, 1)
            this.syncData()
        },
        getToday() {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            var date = yyyy + '-' + mm + '-' + dd
            this.todayDate = date
        },
        charCount(str, letter) {
            var letter_Count = 0;
            for (var position = 0; position < str.length; position++) {
                if (str.charAt(position) == letter) {
                    letter_Count += 1;
                }
            }
            return letter_Count;
        },
        getRoute() {
            var jml = this.charCount(this.$route.path, '/')
            if (jml == 1) {
                this.route = this.$route.path.replace('/', '');
            } else {
                this.route = this.$route.path.substring(
                    this.$route.path.indexOf("/") + 1,
                    this.$route.path.indexOf("/", 2)
                )
            }
        },
        openModal(x, y) {
            this.idxNote = y
            $("#modal" + x).modal('show')
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        toPage(e) {
            this.$router.push(e)
        },
        async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
            localStorage.removeItem('jwt')
            localStorage.removeItem('admin_name')
            localStorage.removeItem('roles')
            localStorage.removeItem('user_email')
            localStorage.removeItem('admin_id')
            localStorage.removeItem('changeCatalogPermission')
            this.$router.push('/')
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/')
            }
        },
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
            for (var i = 0; i < this.permission.length; i++) {
                if (this.permission[i] == "1") {
                    this.viewDashboard = true
                }
                if (this.permission[i] == "2.1") {
                    this.viewOrder = true
                }
                if (this.permission[i] == "2.2") {
                    this.editOrder = true
                }
                if (this.permission[i] == '3.1') {
                    this.viewReturn = true
                }
                if (this.permission[i] == '3.2') {
                    this.editReturn = true
                }
                if (this.permission[i] == '4.1') {
                    this.viewProduct = true
                }
                if (this.permission[i] == '4.2') {
                    this.editProduct = true
                }
                if (this.permission[i] == '5.1') {
                    this.viewPairing = true
                }
                if (this.permission[i] == '5.2') {
                    this.editPairing = true
                }
                if (this.permission[i] == '6') {
                    this.viewReconcile = true
                }
                if (this.permission[i] == '7.1') {
                    this.viewResolution = true
                }
                if (this.permission[i] == '7.2') {
                    this.editResolution = true
                }
                if (this.permission[i] == '8.1') {
                    this.viewLessor = true
                }
                if (this.permission[i] == '8.2') {
                    this.editLessor = true
                }
                if (this.permission[i] == '9.1') {
                    this.viewLessee = true
                }
                if (this.permission[i] == '9.2') {
                    this.editLessee = true
                }
                if (this.permission[i] == '10') {
                    this.viewEmployee = true
                }
            }
            if (this.viewOrder == false) {
                this.$router.push('/')
            }
        },
        getConditionName(status, listData) {
            for (var i = 0; i < listData.length; i++) {
                if (status == listData[i].condition) return listData[i].conditionName
            }
            return ""
        },
        sidebar() {
            $("#wrapper").toggleClass("toggled");
        },
        onChangeLessorPoint(index) {
            // if (this.dataItemPoint[index].lessorPoint.lessorId != 4) {
            //     this.dataItemPoint[index].selectedIds = []
            // } else {
            //     this.dataItemPoint[index].pickupDate = ""
            // }
        },
        getLessorXY(index) {
            var emptyStock = true

            //warehouse on top
            var ListWarehouseOnTop = []
            for (var i = 0; i < this.dataLessorPoint.length; i++) {
                if (this.dataLessorPoint[i].lessorId == 4) {
                    ListWarehouseOnTop.push({
                        pointId: this.dataLessorPoint[i].pointId,
                        pointName: this.dataLessorPoint[i].pointName,
                        lessorId: this.dataLessorPoint[i].lessorId,
                        stock: this.dataLessorPoint[i].stock
                    })
                }
            }
            for (var i = 0; i < this.dataLessorPoint.length; i++) {
                if (this.dataLessorPoint[i].lessorId != 4) {
                    ListWarehouseOnTop.push({
                        pointId: this.dataLessorPoint[i].pointId,
                        pointName: this.dataLessorPoint[i].pointName,
                        lessorId: this.dataLessorPoint[i].lessorId,
                        stock: this.dataLessorPoint[i].stock
                    })
                }
            }
            var lessorList = []
            for (var i = 0; i < ListWarehouseOnTop.length; i++) {
                if (emptyStock && ListWarehouseOnTop[i].lessorId == 4) {

                } else {
                    lessorList.push({
                        pointId: ListWarehouseOnTop[i].pointId,
                        pointName: ListWarehouseOnTop[i].pointName,
                        lessorId: ListWarehouseOnTop[i].lessorId,
                        stock: ListWarehouseOnTop[i].stock
                    })
                }
            }
            return lessorList
        },
        getData() {
            this.productId = this.$route.query.productId
            this.orderId = this.$route.query.orderId
            this.orderCode = this.$route.query.orderCode
            this.companyId = this.$route.query.companyId
            this.condition = this.$route.query.condition
            this.action = this.$route.params.action
            this.maxQty = this.$route.query.qty
            this.previousDate = this.$route.query.deliveryDate
            if(this.$route.query.deliveryDate) {
                let formatDate = this.$route.query.deliveryDate.split('-')
                this.deliveryDate = (formatDate[2] + '-' + formatDate[1] + '-' + formatDate[0])

            }
            console.log('delivery', this.deliveryDate)
            this.$http.get(process.env.GET_ALL_LESSOR, {
                    headers: {
                        'Asani-Token': localStorage.getItem('jwt')
                    }
                })
                .then(response => {
                    console.log('response get all lessor point', response)
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })
                    } else {
                        this.warehouseList = response.data.content
                        this.dataLessorPoint = response.data.content
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                        this.handleLogout()
                        }
                    })
                })

            this.$http.post(process.env.ITEM_ASSIGN_TO, {
                    orderId: this.orderId,
                    productId: this.productId,
                    condition: this.condition,
                    action: this.action,
                    orderItemStatus: this.$route.query.orderItemStatus,
                    deliveryDate: this.$route.query.deliveryDate,
                    orderItemDuration: this.$route.query.orderItemDuration,
                    quantity: this.$route.query.qty,
                    note:this.$route.query.note,
                    price: this.$route.query.price
                }, {
                    headers: {
                        'Asani-Token': localStorage.getItem('jwt')
                    }
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message, "error", {
                            button: "Close",
                        })
                        this.handleLogout()
                    } else if (response.data.status == 201) {
                        swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        }).then((value) => {
                            this.toDetail(this.orderId, this.orderCode, this.companyId)
                        })
                    } else if (response.data.status == 200) {
                        this.productName = response.data.data.productName
                        this.lesseeName = response.data.data.lesseeName
                        this.specificationsView = response.data.data.specificationsView
                        this.paymentDate = response.data.data.paymentDate
                        this.duration = this.$route.query.orderItemDuration.replace(" bulan", "")
  
                        let dataItemPointDefault = []
                        dataItemPointDefault = response.data.data.dataItemPoint
                        this.dataItemPoint = []
                        if (dataItemPointDefault.length == 0) {
                            this.dataItemPoint.push(this.defaultData(0))
                        } else {
                            for (var i = 0; i < dataItemPointDefault.length; i++) {
                                var parseSelectedIds = this.initSelectedIds(dataItemPointDefault[i].stockIds)
                                this.dataItemPoint.push(this.parseData(i, dataItemPointDefault[i].pickupDate, dataItemPointDefault[i].deliveryDate, dataItemPointDefault[i].quantity, dataItemPointDefault[i].lessorId, dataItemPointDefault[i].pointId, dataItemPointDefault[i].stock, dataItemPointDefault[i].pointName, dataItemPointDefault[i].stockPrice, parseSelectedIds))
                                if (this.dataItemPoint[this.dataItemPoint.length - 1].lessorPoint.lessorId == 4) {
                                    this.initSelectAll(this.dataItemPoint[this.dataItemPoint.length - 1].stocks.availableStock, parseSelectedIds)
                                } else {
                                    this.dataItemPoint[this.dataItemPoint.length - 1].selectedIds = []
                                }
                            }
                        }
                        for(let i in this.warehouseList) {
                            if(response.data.content.dataItemPoint[0].pointId == this.warehouseList[i]) {
                                this.lessorSelect = this.warehouseList[i]
                            }
                        }
                    }
                    this.loadingButton = false
                    this.loadingData = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                        this.handleLogout()
                        }
                    })
                })
        },
    },
    watch: {
        deliveryDate: {
            handler: function(val) {
                console.log('date', val)
            }
        },
        lessorSelect: {
            handler: function(val) {
                console.log('lessorselect', val)
            }
        }
    },
    created() {
        this.admin = localStorage.getItem('admin_name')
        this.cekLogin()
        this.cekPermission()
        this.getData()
        this.connectLogOrder()
        this.getRoute()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .paymentDateChips {
        display: inline-block;
        padding: 0 18px;
        font-size: 14px;
        line-height: 20px;
        border-radius: 16px;
    }
    .font-asani{
        font: normal 'Lato', Helvetica, sans-serif;
    }
    .stock-code-item{
        margin-left: 2px;
        margin-right: 2px;
    }
    .lessor-border-3{
        border: 3px solid #DDDDDD;
    }
    .sticky {
      position: fixed;
      top: 0;
      width: 100%;
    }
    .stock-count{
        font-size: 40px;
        color: #2797FA;
        margin-bottom: -15px;
    }
    .title-accordion{
        font: normal normal bold 14px/17px 'Lato', Helvetica, sans-serif;
        letter-spacing: 0px;
        color: #5A5A5A;
        opacity: 1;
        margin-left: 20px;
    }
    .lessor-m-delivery{
        margin-left: 1px;
    }
    .lessor-m-pickup{
        margin-right: 1px;
    }
    .lessor-bg-content{
        background: #F4F4F4 0% 0% no-repeat padding-box;
        opacity: 1;
    }
    .lessor-bg-content-field{
        background-color: #E8E8E8;
        border: 3px solid #DDDDDD;
    }
    .lessor-bg-content-stock-count{
        background-color: #E8E8E8;
    }
    .lessor-rounded-add{
        border-radius: 7px 0px 7px 7px;
    }
    .lessor-rounded{
        border-radius: 7px;
    }
    .lessor-point-field{
        width: 100%;
    }
    .lessor-icon-pickup{
        margin: -3px;
        max-width: 160px;
    }
    .lessor-icon-delivery{
        margin: -3px;
        max-width: 160px;
    }
    .lessor-icon{
        margin: -3px;
        max-width: 160px;
    }
    .lessor-icon-not-warehouse{
        margin: -3px;
        max-width: 160px;
    }
    .lessor-icon-delete{
        max-width: 23px;
    }
    .lessor-bg-icon-delete{
        border-radius: 7px 7px 0px 0px;
        width: 53px;
    }
    .lessor-bg-icon-delete:hover{
        cursor: pointer;
        background-color: #E8E8E8;
    }
</style>



// WEBPACK FOOTER //
// src/components/Order/SetLessorPage.vue